module.exports = __webpack_public_path__ + "img/65732.7480463d.png";